import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ColumnPreferenceTab } from 'src/app/modules/setting/column-preference/column-preference.component';
import { UserPreferenceEnum } from 'src/app/modules/setting/setting/setting.component';
import { LocalStorage } from 'src/app/shared/entity/enums';
import { ColumnList, ColumnPreference, SelectedColumnPreferences } from 'src/app/shared/models/column-preference';
import { SelectedPreferencesENUM } from 'src/app/shared/models/preference';
import { ColumnService } from 'src/app/shared/services/column-services/column.service';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { UserPreferencesService } from 'src/app/shared/services/user-preferences/user-preferences.service';
import ColumnPreferenceJSON from 'src/assets/data/columnpreference.json';
import TaskBankJSON from 'src/assets/data/taskbank.json';

@Injectable({
  providedIn: 'root'
})
export class TaskbankColumnService {
  columnConfigurations:{[key: string]: { field: string; label: string; visible: boolean; order:number; width?:string}[] }=
  {
    Planned : [
      { field: 'pbm_order_id', label: 'Order Id', visible: true,order:1, width: '110px'},
      { field: 'route_name', label: 'Route', visible: true,order:2, width: '88px' },
      { field: 'stop_sequence', label: 'Stop', visible: true,order:3, width: '50px'},
      { field: 'task_sequence', label: 'Task', visible: true,order:4, width: '50px'  },
      { field: 'task_point_name', label: 'Task Point Name', visible: true,order:5, width: '135px' },
      { field: 'address', label: 'Address', visible: true,order:6, width: '82px' },
      { field: 'postal_code', label: 'Postal Code', visible: true,order:7, width: '113px' },
      { field: 'delivery_point_area_name', label: 'DLA', visible: true,order:8, width: '69px' },
      { field: 'outside_sp_perimeter', label: 'Perimeter', visible: true,order:9, width: '75px' },
      { field: 'item_count', label: 'Items', visible: true,order:10, width: '65px' },
      { field: 'goods_count', label: 'Goods', visible: true,order:11, width: '53px' },
      { field: 'quantity', label: 'Quantity', visible: true,order:12, width: '77px' },
      { field: 'task_type', label: 'Type', visible: true,order:13, width: '51px' },
      { field: 'source', label: 'Source', visible: true,order:14, width: "78px"},
      { field: 'initial_eta', label: 'IETA', visible: true,order:15, width: '50px' },
      { field: 'eta', label: 'RETA', visible: true,order:16, width: '50px' },
      { field: 'ata', label: 'ATA', visible: true,order:17, width: '46px' },
      { field: 'task_time_window', label: 'Time Window', visible: true,order:18, width: '127px' },
      { field: 'task_state', label: 'Status', visible: true,order:19, width: '80px' },
      { field: 'weight', label: 'Weight', visible: true,order:20, width: '83px' },
      { field: 'volume', label: 'Volume', visible: true,order:21, width: '58px' },
      { field: 'product_codes', label: 'Product Codes', visible: true,order:22, width: '125px' }
    ],
    ['Unplanned Pickup']: [
      { field: 'pbm_order_id', label: 'Order Id', visible: true,order:1, width: '110px'},
      { field: 'route_name', label: 'Route', visible: true,order:2, width: '88px' },
      { field: 'bl_name', label: 'BLOM Location', visible: true,order:3, width: '130px'},
      { field: 'task_point_name', label: 'Task Point Name', visible: true,order:4, width: '135px'},
      { field: 'address', label: 'Address', visible: true,order:5, width: '82px'},
      { field: 'postal_code', label: 'Postal Code', visible: true,order:6, width: '113px'},
      { field: 'delivery_point_area_name', label: 'DLA', visible: true,order:7, width: '69px'},
      { field: 'item_count', label: 'Items', visible: true,order:8, width: '65px'},
      { field: 'goods_count', label: 'Goods', visible: true,order:9, width: '53px'},
      { field: 'quantity', label: 'Quantity', visible: true,order:10, width: '77px'},
      { field: 'reason_code', label: 'Reason Code', visible: true,order:11, width: '115px'},
      { field: 'user_name', label: 'User Information', visible: true,order:12, width: '149px' },
      { field: 'task_time_window', label: 'Time Window', visible: true,order:13, width: '127px'},
      { field: 'driver_instruction', label: 'Driver Note', visible: true,order:14, width: '111px' },
      { field: 'manager_instruction', label: 'Manager Note', visible: true,order:15, width: '123px' },
      { field: 'vehicle_type', label: 'Vehicle Type ', visible: true,order:16, width: '100px' },
      { field: 'source', label: 'Source', visible: true,order:17, width: '78px' },
      { field: 'task_type', label: 'Type', visible: true,order:18, width: '73px' },
      { field: 'task_state', label: 'Status', visible: true,order:19, width: '80px' },
      { field: 'weight', label: 'Weight', visible: true,order:20, width: '83px' },
      { field: 'volume', label: 'Volume', visible: true,order:21, width: '58px' }
    ],
    Unloaded :[
      { field: 'route_name', label: 'CSP Route', visible: true,order:1, width: '110px'  },
      { field: 'bl_name', label: 'BLOM Location', visible: true,order:2, width: '130px'  },
      { field: 'task_point_name', label: 'Task Point Name', visible: true,order:3, width: '135px'  },
      { field: 'address', label: 'Address', visible: true,order:4, width: '82px'  },
      { field: 'postal_code', label: 'Postal Code', visible: true,order:5, width: '113px' },
      { field: 'delivery_point_area_name', label: 'DLA', visible: true,order:6, width: '69px'  },
      { field: 'pn_item_id', label: 'Barcode', visible: true,order:7, width: '90px'  },
      { field: 'consignee_name', label: 'Consignee Name', visible: true,order:8, width: '140px'  },
      { field: 'user_name', label: 'User Information', visible: true,order:9, width: '99px'  },
      { field: 'item_state', label: 'Item State', visible: true,order:10, width: '80px'  },
      { field: 'source', label: 'Source', visible: true,order:11, width: '53px'  }
    ],
    ['Push To Cloud'] :[
      { field: 'bl_name', label: 'BLOM Location', visible: true,order:1, width: '130px' },
      { field: 'task_point_name', label: 'Task Point Name', visible: true,order:2, width: '135px' },
      { field: 'address', label: 'Address', visible: true,order:3, width: '82px' },
      { field: 'postal_code', label: 'Postal Code', visible: true,order:4, width: '113px' },
      { field: 'delivery_point_area_name', label: 'DLA', visible: true,order:5, width: '69px' },
      { field: 'item_count', label: 'Items', visible: true,order:6, width: '65px' },
      { field: 'task_time_window', label: 'Time Window', visible: true,order:7, width: '127px' },
      { field: 'user_name', label: 'User Information', visible: true,order:8, width: '149px' },
      { field: 'source', label: 'Source', visible: true,order:9, width: '53px' },
      { field: 'task_type', label: 'Type', visible: true,order:10, width: '45px' },
      { field: 'task_state', label: 'Status', visible: true,order:11, width: '80px' },
      { field: 'weight', label: 'Weight', visible: true,order:12, width: '83px' },
      { field: 'volume', label: 'Volume', visible: true,order:13, width: '58px' }
    ],
    ['Planned PBM'] :[
      { field: 'route_name', label: 'Route', visible: true,order:1, width: '110px' },
      { field: 'pbm_order_id', label: 'Order Id', visible: true,order:2, width: '110px' },
      { field: 'bl_name', label: 'BLOM Location', visible: true,order:3, width: '130px' },
      { field: 'task_point_name', label: 'Task Point Name', visible: true,order:4, width: '135px' },
      { field: 'address', label: 'Address', visible: true,order:5, width: '82px' },
      { field: 'postal_code', label: 'Postal Code', visible: true,order:6, width: '113px' },
      { field: 'delivery_point_area_name', label: 'DLA', visible: true,order:7, width: '69px' },
      { field: 'item_count', label: 'Items', visible: true,order:8, width: '65px'},
      { field: 'goods_count', label: 'Goods', visible: true,order:9, width: '53px' },
      { field: 'quantity', label: 'Quantity', visible: true,order:10, width: '77px' },
      { field: 'task_time_window', label: 'Time Window', visible: true,order:11, width: '127px' },
      { field: 'driver_instruction', label: 'Driver Note', visible: true,order:12, width: '111px' },
      { field: 'manager_instruction', label: 'Manager Note', visible: true,order:13, width: '123px' },
      { field: 'reason_code', label: 'Reason Code', visible: true,order:14, width: '115px'},
      { field: 'user_name', label: 'User Information', visible: true,order:15, width: '149px' },
      { field: 'vehicle_type', label: 'Vehicle Type ', visible: true,order:16, width: '100px' },
      { field: 'source', label: 'Source', visible: true,order:17, width: '53px' },
      { field: 'task_type', label: 'Type', visible: true,order:18, width: '73px' },
      { field: 'task_state', label: 'Status', visible: true,order:19, width: '80px' },
      { field: 'weight', label: 'Weight', visible: true,order:20, width: '83px' },
      { field: 'volume', label: 'Volume', visible: true,order:21, width: '58px' }
      ],
      ['Previous Day Orders']: [
        { field: 'route_name', label: 'Route', visible: true,order:0, width: '88px' },
        { field: 'pbm_order_id', label: 'Order Id', visible: true,order:0, width: '110px' },
        { field: 'bl_name', label: 'BLOM Location', visible: true,order:0, width: '130px' },
        { field: 'task_point_name', label: 'Task Point Name', visible: true,order:0, width: '135px' },
        { field: 'address', label: 'Address', visible: true,order:0, width: '82px' },
        { field: 'postal_code', label: 'Postal Code', visible: false,order:0, width: '113px' },
        { field: 'delivery_point_area_name', label: 'DLA', visible: false,order:0, width: '69px' },
        { field: 'item_count', label: 'Items', visible: true,order:0, width: '65px' },
        { field: 'goods_count', label: 'Goods', visible: true,order:0, width: '53px' },
        { field: 'quantity', label: 'Quantity', visible: true,order:0, width: '77px' },
        { field: 'task_time_window', label: 'Time Window', visible: false,order:0, width: '127px' },
        { field: 'driver_instruction', label: 'Driver Note', visible: true,order:0, width: '111px' },
        { field: 'manager_instruction', label: 'Manager Note', visible: true,order:0, width: '123px' },
        { field: 'reason_code', label: 'Reason Code', visible: true,order:0, width: '115px' },
        { field: 'user_name', label: 'User Information', visible: true,order:0, width: '149px' },
        { field: 'vehicle_type', label: 'Vehicle Type ', visible: false,order:0, width: '100px' },
        { field: 'source', label: 'Source', visible: false,order:0, width: '73px' },
        { field: 'task_type', label: 'Type', visible: true,order:0, width: '80px' },
        { field: 'task_state', label: 'Status', visible: true,order:0, width: '80px' },
        { field: 'weight', label: 'Weight', visible: false,order:0, width: '83px' },
        { field: 'volume', label: 'Volume', visible: false,order:0, width: '58px' }
      ],
  }
  updateColumns = new BehaviorSubject(false);
  columnPrint = ['pbm_order_id','route_name', 'bl_name', 'task_point_name', 'address', 'postal_code', 'item_count', 'goods_count', 'quantity', 'task_time_window', 'driver_instruction', 'vehicle_type', 'task_type', 'weight', 'volume'];

  visibleColumnsList:{
    id:string,
    value:string,
    enable: boolean,
    width: string
  }[] = []
  constructor(private readonly userPreferenceService: UserPreferencesService,
    private readonly dataRepositoryService: DataRepositoryService,
    private readonly columnService: ColumnService
  ) {
  }

  getWidth(column: any) {
    return column.width ? column.width : '';
  }


 /**
  * Get the list of visible columns for a each tab, where component key is tab name
  */
  getVisibleColumns(componentKey: string, columns?: ColumnList[]) {
    let visibleFields = new Map(); 
    columns?.forEach(item => {
      visibleFields.set(item.id, item);
    });
    const fields  =  this.columnConfigurations[componentKey]?.map(col => {
      const visibleColumn = visibleFields.get(col.field);
      col.width = visibleColumn?.width??col.width;
      col.order = visibleColumn?.order??col.order
      return {...col}
    })
      ?.filter((column: any) => {
        const isEnabled = visibleFields.get(column.field);
        return isEnabled ? isEnabled !== false && isEnabled?.enable : true;
      });
    return fields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  mergeSavedColumns(defaultColumns: ColumnList[], savedColumns: ColumnList[]) {
    const savedMap = new Map(savedColumns?.map(col => [col.id, col]));

    const merged = defaultColumns.map(defaultCol => {
      const saved = savedMap.get(defaultCol.id);
      return saved
        ? { ...defaultCol, ...saved } // use saved config where available
        : { ...defaultCol, enable: true }; // new column → enable by default
    });
 
    const defaultIds = new Set(defaultColumns.map(c => c.id));
    const extraSaved = savedColumns?.filter(c => !defaultIds.has(c.id));

    return [...merged, ...extraSaved??[]].sort((a, b) => a.order - b.order);
  }



  /**
   * To save column width in backend user preference
   * @param event 
   */
  saveColumnWidth(event:any, visibleColumnList:any[]) {
    const columnId = event.element.id;
    const newWidth = event.element.offsetWidth;
    this.setColumnWidth(columnId, newWidth, visibleColumnList)
  }
 
  /**
   * 
   * @param columnId 
   * @param newWidth 
   */
  setColumnWidth(columnId: string, newWidth: string, visibleColumnList:any[]) {
    const currentPreference = this.dataRepositoryService.selectedUserColumnPreferences()?.[SelectedPreferencesENUM.TASKBANK];
    
    let columnList = [...visibleColumnList]
    const columnIndex = columnList.findIndex((col: any) => col.field === columnId);
    if (columnIndex !== -1) {
      columnList[columnIndex].width = `${Math.round(Number(newWidth))}px`
    }
    const updatedSelectedPreference = this.updateColumnWidths(columnList, currentPreference ?? null);
    this.updateSelectedPreference(updatedSelectedPreference);
    this.updateColumnList(updatedSelectedPreference);
  }

  // Assumes input is produced by updateColumnWidths in this service (called from setColumnWidth).
  // If new callers are added, re-evaluate whether permanent-preference width mapping is needed.
  updateSelectedPreference(updatedSelectedPreference: ColumnPreference) {
    if(updatedSelectedPreference) {
      const sourceColumnList = updatedSelectedPreference.columnList;

      const targetColumnList: ColumnPreference = {
        ...updatedSelectedPreference,
        columnList: updatedSelectedPreference.columnList
      };
      const currentPrefs = this.dataRepositoryService.selectedUserColumnPreferences();
      const newPrefs: SelectedColumnPreferences = currentPrefs ? { ...currentPrefs } : {};
      newPrefs[SelectedPreferencesENUM.TASKBANK] = targetColumnList;
      this.dataRepositoryService.selectedUserColumnPreferences.set({...newPrefs});

      // Update tempSelectedUserColumnPreferences — preserve temporary order, only apply new widths
      const tempPref = this.dataRepositoryService.tempSelectedUserColumnPreferences()?.[SelectedPreferencesENUM.TASKBANK] ?? this.generateDefaultColumnList();
      const tempTargetColumnList: ColumnPreference = {
        ...tempPref,
        columnList: tempPref.columnList?.map(targetCol => {
          const sourceCol = sourceColumnList.find(src => src.id === targetCol.id);
          return sourceCol ? { ...targetCol, width: sourceCol.width } : { ...targetCol };
        }) ?? []
      };
      const currentTempPrefs = this.dataRepositoryService.tempSelectedUserColumnPreferences();
      const newTempPrefs: SelectedColumnPreferences = currentTempPrefs ? { ...currentTempPrefs } : {};
      newTempPrefs[SelectedPreferencesENUM.TASKBANK] = tempTargetColumnList;
      this.dataRepositoryService.tempSelectedUserColumnPreferences.set({...newTempPrefs});
      
      this.columnService.saveUserPreference(this.dataRepositoryService?.selectedUserColumnPreferences()??{} as SelectedColumnPreferences);
    }
  }

  
  /**
   * Updates the user's selected column preference.
   * 
   * @param updatedSelectedPreference - The new column preference to be saved and reflected in the UI.
   */
  updateColumnList(updatedSelectedPreference:ColumnPreference | null) {
    // Don't save Default preference to the column preferences list (it's generated dynamically)
    // But it will still be saved to selectedUserColumnPreferences for width persistence
    if(updatedSelectedPreference?.id === 'DefaultColumnTaskBank') {
      return;
    }
    
    if(updatedSelectedPreference) {
      this.userPreferenceService
      .saveUserPreference(UserPreferenceEnum.USERCOLUMNPREFERENCES, updatedSelectedPreference, false)
      .subscribe();
      
      let columnList:ColumnPreference[] = this.dataRepositoryService.userColumnPreferencesList();
      const columnIndex = columnList.findIndex(x => x.id === updatedSelectedPreference?.id);
      if(columnIndex !== -1) {
        columnList[columnIndex] = updatedSelectedPreference;
        this.dataRepositoryService.userColumnPreferencesList.update(()=> [...columnList])
      }
    }
  }
  
  /**
   * Updates the column widths in a column preference structure.
   * 
   * @param updatedColumnList - List of columns with updated width values.
   * @param originalStructure - The original column preference structure to be updated.
   * @returns A new column preference structure with updated widths.
   */
  updateColumnWidths(updatedColumnList: any[], originalStructure: ColumnPreference | null): any {
    let updatedStructure = originalStructure ? { ...originalStructure, columnList: [...originalStructure.columnList] } : this.generateDefaultColumnList();
    if (updatedStructure) {
      updatedStructure.columnList = updatedStructure.columnList.map((col: any) => {
        const match = updatedColumnList.find(u => u.field === col.id);
        
        if (match) {
          return { ...col, width: match.width };  // Update width
        }
        return col;  // No match, return the original column
      });
      
      return updatedStructure;
    }
  }


  generateDefaultColumnList() {
    return {
      name: "Default Columns",
      id: "DefaultColumnTaskBank",
      columnList: TaskBankJSON.map(col => ({...col})), // Deep copy to ensure immutability
      type: ColumnPreferenceTab.TASKBANK,
      description: "",
      createdDate: "",
    };
  }
}
